import axiosInstance from '../helpers/axios';

/**
 * POST /api/ops/classes/:id/send — the sends a person makes from a class,
 * each with its status side effect: the prep-call request (status →
 * Requested, a case opened), the travel trigger (→ Required – Initiated),
 * the formal instructor request (a case at Instructor Request), the
 * availability check to any trainer (a case at With Scheduling), and the
 * registration link.
 */
export type TClassSendKind =
  | 'prep-call'
  | 'travel'
  | 'instructor-request'
  | 'availability'
  | 'reg-link';
export type TPrepCallVariant = 'ft' | 'part-time' | 'series';
export type TRegLinkVariant = 'poc' | 'student';

export type TClassSendBody = {
  kind: TClassSendKind;
  variant?: TPrepCallVariant | TRegLinkVariant;
  to?: string;
  /** reg-link to learners: one message per address */
  recipients?: string[];
  note?: string;
  /** availability: the trainer to ask, by name; defaults to the one on the class */
  instructor?: string;
};

export type TClassSendResult = {
  kind: TClassSendKind;
  to: string;
  cc?: string[];
  status: string;
  holdReason?: string | null;
  outboxId: string;
  templateName?: string;
  variant?: TPrepCallVariant | TRegLinkVariant;
  caseId?: string | null;
  caseNumber?: string;
  caseStatus?: string;
  instructor?: string | null;
  financeCcMissing?: boolean;
  statusSet?: { prepCallStatus?: string; travelStatus?: string };
  /** reg-link: how many messages, the link merged, the cutover note */
  count?: number;
  link?: string | null;
  warning?: string | null;
};

export const sendFromClass = async (classId: string, body: TClassSendBody) =>
  (
    await axiosInstance.post<TClassSendResult>(
      `ops/classes/${encodeURIComponent(classId)}/send`,
      body,
    )
  ).data;
